import React, { useRef } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'
import Typography from '@mui/material/Typography'
import TextFieldItem from './TextFieldItem'
import { RootActionType, RootState } from 'duck'
import { actions, selectors } from '../../duck'
import { ReduxProps } from 'utils/Types'
import Button from 'components/Button'
import PaymentDetails from './PaymentDetails'
import { useBreakpoint } from 'utils/Hooks'
import Pricing from './Pricing'
import { scrollTo } from 'utils/MiscUtils'
import stylesGlobal from 'stylesGlobal.module.scss'
import styles from '../NFTSellForm.module.scss'

const mapStateToProps = (state: RootState) => ({
  formData: selectors.formData(state)
})

const mapDispatchToProps = (dispatch: Dispatch<RootActionType>) =>
  bindActionCreators(
    {
      continueForm: actions.continueForm
    },
    dispatch
  )

type DialogFormSellNftProps = ReduxProps<typeof mapStateToProps, typeof mapDispatchToProps> & {
  scrollRef?: React.MutableRefObject<HTMLDivElement | null>
}

const NFTSellFormDialog: React.FC<DialogFormSellNftProps> = props => {
  const { continueForm, formData, scrollRef } = props

  const { isMediumscreenAbove } = useBreakpoint()
  const detailsSectionRef = useRef<HTMLDivElement | null>(null)
  const contactSectionRef = useRef<HTMLDivElement | null>(null)
  const priceSectionRef = useRef<HTMLDivElement | null>(null)
  const hasDetailsError = !formData?.title || !formData?.description
  const hasContactError = !formData?.email
  const hasPricingError = !formData?.start_price || !formData?.end_price

  return (
    <div className={clsx('mx-auto', styles.FormWrapper)}>
      <div
        ref={detailsSectionRef}
        className={clsx(isMediumscreenAbove ? 'mb-11' : 'mb-8', stylesGlobal.BorderBottomOnSurface)}
      >
        <Typography variant="h6" className="mb-7">
          Project Details
        </Typography>

        <TextFieldItem className="mb-6" formDataType={'title'} label="Title" />

        <TextFieldItem className="mb-6" formDataType={'user_full_name'} label="Created By" />

        <TextFieldItem
          className="mb-6"
          formDataType={'description'}
          label="Description"
          multiline
        />
      </div>

      <div
        ref={contactSectionRef}
        className={clsx(isMediumscreenAbove ? 'mb-11' : 'mb-8', stylesGlobal.BorderBottomOnSurface)}
      >
        <Typography variant="h6" className="mb-7">
          Creator Contact
        </Typography>

        <TextFieldItem
          className="mb-6"
          formDataType={'email'}
          label="Email (optional, visible only to your buyers)"
        />

        <TextFieldItem className="mb-6" formDataType={'twitter_url'} label="Twitter (optional)" />

        <TextFieldItem formDataType={'instagram_url'} label="Instagram (optional)" />
      </div>

      <Pricing setRef={priceSectionRef} />

      <PaymentDetails />

      <div>
        <Button
          color="secondary"
          variant="contained"
          fullWidth
          onClick={() => {
            if (hasDetailsError) {
              scrollTo?.({
                el: scrollRef?.current,
                y: detailsSectionRef.current?.offsetTop
                  ? detailsSectionRef.current?.offsetTop - 24
                  : undefined
              })
            } else if (hasContactError) {
              scrollTo?.({
                el: scrollRef?.current,
                y: contactSectionRef.current?.offsetTop
                  ? contactSectionRef.current?.offsetTop - 24
                  : undefined
              })
            } else if (hasPricingError) {
              scrollTo?.({
                el: scrollRef?.current,
                y: priceSectionRef.current?.offsetTop
                  ? priceSectionRef.current?.offsetTop - 24
                  : undefined
              })
            }

            continueForm()
          }}
        >
          SUBMIT PROJECT
        </Button>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(NFTSellFormDialog)

/*

For future inmprovement
        <TextFieldItem
          className={clsx(stylesGlobal.MarginBottom24)}
          tooltipData={{
            className: stylesGlobal.TextWhiteMedTextOnDark,
            classes: {
              tooltip: stylesGlobal.MaxWidthNone
            },
            title: (
              <Typography variant="caption">
                <span className={stylesGlobal.TextWhiteHiTextOnDark}>Some things to consider:</span>
                <br />
                - Playform supports up to 10,000 unique NFTs.
                <br />
                - How big is your social reach?
                <br />- How many people could you provide the incentives?
              </Typography>
            )
          }}
          type={'number'}
          formDataType={'number_of_nft'}
          label="Number of NFTs"
        />

*/
